const CantHeardIt = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 96 96" fill="none">
            <path d="M28.5 28.5L67.5 67.5M67.5 28.5L28.5 67.5L67.5 28.5Z" stroke="#FEFEFE" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
export default CantHeardIt